let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("rEW7g")).then(() => parcelRequire('cusNu'));